import React from 'react';

import { Spinner } from '../../spinner/spinner';

export interface DefaultPrimaryButtonProps {
    id?: string;
    text: React.ReactNode;
    onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    isLoading?: boolean;
    styles?: {
        submitButton?: string;
    };
    size?: 'sm' | 'md' | 'lg';
    dataTestId?: string;
}

const variant = {
    sm: 'h-10 px-3 text-sm',
    md: 'h-12 px-4 text-base',
    lg: 'h-14 px-5 text-base min-w-48'
};

export const DefaultPrimaryButton = (props: DefaultPrimaryButtonProps) => {
    return (
        <button
            id={props.id}
            disabled={props.disabled || props.isLoading}
            onClick={props.onClick}
            data-testid={props.dataTestId ?? 'primary-button'}
            className={`${props.styles?.submitButton ?? `bg-brand-primary disabled:bg-brand-disabled hover:bg-brand-secondary border-brand-primary disabled:border-brand-disabled hover:border-brand-secondary inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl border disabled:cursor-not-allowed ${props.size ? variant[props.size] : variant.md}`}`}>
            <div className='text-background-surface flex content-center items-center justify-center gap-2 font-medium whitespace-nowrap'>
                {props.isLoading && <Spinner className='text-border-default fill-brand-primary size-4' />}
                {props.text}
            </div>
        </button>
    );
};
